import { errorTranslations } from "schema"

export default {
  errors: errorTranslations["es-ES"],
}
